import { loginApi } from '../../setup/setupApi';
import { AgeRestrictions } from './types';

export const getAgeRestrictions = (projectId: string): Promise<AgeRestrictions> =>
  loginApi.get(`projects/${projectId}/age_rating`).then((res) => res.data);

export const updateBatchAgeRestrictions = (
  projectId: string,
  ageRestrictions: AgeRestrictions
): Promise<AgeRestrictions> =>
  loginApi.post(`projects/${projectId}/age_rating/batch`, ageRestrictions).then((res) => res.data);
